
// Initial score data for Level 2 Training

export const initialScores = {
  "putts-plat": {},
  "putts-montee": {},
  "putts-descente": {},
  "putts-pente": {},
  "putts-pente-droite": {},
  "chipping-plat": {},
  "chipping-pente-droit": {},
  "chipping-pente-gauche": {},
  "chipping-roulee-plat": {},
  "wedging-cercles": {},
  "wedging-mid": {},
  "wedging-pente-gauche": {},
  "bunker-court": {},
  "bunker-long": {},
  "iron-long": {},
  "iron-mid": {},
  "iron-green-attack-100": {},
  "fairwayWood-3": {},
  "fairwayWood-5": {},
  "driver-practice": {},
  "driver-accuracy": {}
};

export const levels = {
  "0": "Niveau 2 débutant",
  "120": "Niveau 2 intermédiaire",
  "240": "Niveau 2 avancé"
};
